export default {
  color: {
    en: '<span class="semibold">Color</span> — {colorName}',
  },
}
